/**
 * Enumeration representing return values from dialogs
 */
export enum DialogButton {
  /** An error occurred in the dialog */
  Error = -1,

  /** The user clicked the OK button */
  OK = 0,

  /** The user clicked the cancel button */
  Cancel = 1
}
